import { render, staticRenderFns } from "./TabInvitaciones.vue?vue&type=template&id=40d615de&scoped=true"
import script from "./TabInvitaciones.vue?vue&type=script&lang=js"
export * from "./TabInvitaciones.vue?vue&type=script&lang=js"
import style0 from "./TabInvitaciones.vue?vue&type=style&index=0&id=40d615de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d615de",
  null
  
)

export default component.exports